import {ReactComponent as Icon} from '@image/icon_sound.svg';

const IconSound = () => {
    return   <Icon />;
};

export default IconSound;